<template>
	<router-view />
</template>
<script>
	import "@/assets/css/layout.css";
	import "@/assets/css/contents.css";
	
	export default {

	}
</script>
<style>
</style>